import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-[#1A1A1A] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-[#00E5FF] focus:ring-1 focus:ring-[#00E5FF] transition-[border-color,box-shadow] duration-300";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! We'll get back to you soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} data-testid="contact-form" className="bg-[#121212] border border-white/5 rounded-2xl p-8 md:p-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="contact-name" className="text-sm text-[#A1A1A6] mb-2 block">Name *</Label>
          <input id="contact-name" data-testid="contact-name-input" required value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Your name" className={inputCls} />
        </div>
        <div>
          <Label htmlFor="contact-email" className="text-sm text-[#A1A1A6] mb-2 block">Email *</Label>
          <input id="contact-email" data-testid="contact-email-input" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="you@example.com" className={inputCls} />
        </div>
      </div>
      <div className="mt-6">
        <Label htmlFor="contact-phone" className="text-sm text-[#A1A1A6] mb-2 block">Phone</Label>
        <input id="contact-phone" data-testid="contact-phone-input" type="tel" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="(306) 555-0123" className={inputCls} />
      </div>
      <div className="mt-6">
        <Label htmlFor="contact-message" className="text-sm text-[#A1A1A6] mb-2 block">Message *</Label>
        <textarea id="contact-message" data-testid="contact-message-input" rows="5" required value={form.message} onChange={(e) => set("message", e.target.value)} placeholder="Tell us about your photo, your idea, or ask us anything..." className={`${inputCls} resize-none`} />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="contact-submit-button"
        className="mt-8 w-full bg-white text-black font-tech text-xs uppercase tracking-[0.2em] font-semibold px-8 py-4 rounded-full hover:bg-cyan-200 transition-[background-color,box-shadow,transform] duration-300 shadow-[0_0_20px_rgba(0,229,255,0.3)] hover:shadow-[0_0_30px_rgba(0,229,255,0.5)] hover:-translate-y-0.5 disabled:opacity-60"
      >
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>
  );
};
